import { NaturalPersonFormValues } from "../types/naturalPersonFormValues";
import { naturalPersonValidationRules } from "../form/validation-rules/naturalPersonValidationRules";
import { LegalEntityFormValues } from "../types/legalEntityFormValues";
import { legalEntityValidationRules } from "../form/validation-rules/legalEntityValidationRules";
import { formConfigInitData } from "../form/formConfigInitData";
import { createFormConfig, ValidationRules } from "helpers/createFormConfig";

/**
 * Form configurations of the natural person and legal entity actor forms.
 */
export const useEnhancedFormConfig = (productId?: string) => {
  const naturalPersonFormConfig = createFormConfig<NaturalPersonFormValues>(
    naturalPersonValidationRules as ValidationRules<keyof NaturalPersonFormValues>,
    formConfigInitData
  )

  const legalEntityFormConfig = createFormConfig<LegalEntityFormValues>(
  legalEntityValidationRules as ValidationRules<keyof LegalEntityFormValues>,
    formConfigInitData
);

  return {
    naturalPersonFormConfig,
    legalEntityFormConfig,
  };
};
